import { useState, useMemo, useEffect } from "react"

import checkForShopLink from "../utils/checkForShopLink"

const useFooter = (article) => {
  const { elements } = article

  // check elements for products for supplements disclaimer & tags
  const showSupplementsDisclaimer = useMemo(
    () => elements.some((element) => checkForShopLink(element)),
    [elements],
  )
  const [bottomStickyProduct, setBottomStickyProduct] = useState(null)

  useEffect(() => {
    document.querySelector("#footer_disclaimer").style.display = showSupplementsDisclaimer
      ? "block"
      : "none"
    // document.querySelector("#footer").style.paddingBottom = bottomStickyProduct ? "7rem" : ""
  }, [showSupplementsDisclaimer, bottomStickyProduct])

  return { showSupplementsDisclaimer, bottomStickyProduct, setBottomStickyProduct }
}

export default useFooter
